import {
  validatePresence,
  validateFormat,
} from 'ember-changeset-validations/validators';
import validateUniqueUserEmail from '../../validators/unique-user-email';
import validateEmailDomain from '../../validators/email-domain';
import UserModel from 'donor-elf-web/models/user';

export default function validateCreateUser({
  allUsers,
}: {
  allUsers: UserModel[];
}) {
  return {
    firstName: validatePresence(true),
    lastName: validatePresence(true),
    email: [
      validateFormat({ type: 'email', message: 'Invalid email address' }),
      validateUniqueUserEmail({ allUsers }),
      validateEmailDomain(),
    ],
    role: validatePresence(true),
  };
}
